<template>
  <v-container fluid class="pt">
    <v-layout row wrap>
      <v-card class="elevation-0 shadow-md white mt-2 flex xs12">
        <v-card-text class="pt-4">
          <v-layout row wrap>
            <v-flex xs12 md4 class="di-flex align-center">
              <template v-if="can.add && !kyc">
                <v-btn
                  color="primary"
                  to="individuals/new"
                  v-if="$vuetify.breakpoint.mdAndUp"
                >
                  <v-icon class="mx-2">add_circle</v-icon>
                  <span class="mt-1">
                    {{ $t("new_customer") }}
                  </span>
                </v-btn>
                <!-- @click="showDialog" -->

                <v-btn
                  icon
                  flat
                  v-else
                  class="mx-0"
                  color="primary"
                  @click="showDialog"
                >
                  <v-icon>add_circle</v-icon>
                </v-btn>
              </template>
              <strong v-if="kyc" class="body-2 px-3 py-2 lable-out grey6">{{
                title
              }}</strong>
              <!-- <div v-if="kyc" class="red di-flex"> -->

              <!-- </div> -->
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 md7 class="di-flex justify-end align-center">
              <v-text-field
                outline
                singleLine
                hide-details
                v-model="search"
                class="rounded"
                style="max-width: 400px"
                :placeholder="$t('search')"
                prepend-inner-icon="search"
              />
              <v-btn
                flat
                icon
                class="mx-0"
                color="grey darken-2"
                @click="printTable(false)"
              >
                <v-icon>print</v-icon>
              </v-btn>
              <v-btn
                flat
                icon
                class="mx-0"
                color="grey darken-2"
                @click="printTable(true)"
              >
                <v-icon>file_download</v-icon>
              </v-btn>
              <v-btn
                flat
                icon
                class="mx-0"
                @click="getData"
                :loading="loading"
                color="grey darken-2"
              >
                <v-icon>refresh</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="kyc" class="pa-2 my-2 shadow-md">
            <v-checkbox
              singleLine
              hideDetails
              color="primary"
              @change="getData"
              v-model="trashed"
              class="flex xs12 md3"
              style="max-width: 200px"
              :label="$t('deactivated')"
            />
            <v-checkbox
              singleLine
              hideDetails
              class="flex xs12 md3"
              color="primary"
              @change="getData"
              v-model="temporary"
              style="max-width: 200px"
              :label="$t('temporary')"
            />
            <v-checkbox
              singleLine
              hideDetails
              v-model="pep"
              color="primary"
              @change="getData"
              :label="$t('pep')"
              class="flex xs12 md3"
              style="max-width: 200px"
            />

            <v-checkbox
              singleLine
              hideDetails
              color="primary"
              @change="getData"
              class="flex xs12 md3"
              style="max-width: 200px"
              v-model="sanction_screening"
              :label="$t('sanction_screening')"
            />
          </v-layout>
          <!-- <div class="di-flex flex align-center mb-3">
            <v-spacer />
            
          </div> -->
          <v-data-table
            ref="tbl"
            item-key="id"
            :items="items"
            class="flex xs12"
            :loading="loading"
            :headers="headers"
            v-model="selected"
            :total-items="meta.total"
            :pagination.sync="pagination"
            :rows-per-page-items="per_page"
          >
            <template slot="items" slot-scope="{ item, index }">
              <tr>
                <td :class="{ red: item.deleted_at }">{{ index + 1 }}</td>
                <td>{{ item.branch && item.branch.code }}</td>
                <td>{{ item.customer_id }}</td>
                <td>
                  <router-link :to="`individuals/${item.customer_id}`">
                    {{ item.full_name }}
                  </router-link>
                </td>
                <td>{{ item.pretty_phones }}</td>
                <td>{{ item.tazkira_no }}</td>
                <td>{{ item.passport_no }}</td>
                <td>{{ item.current_address }}</td>
                <td>{{ item.reg_date }}</td>
                <template v-if="kyc">
                  <td>{{ item.kyc_updated_date }}</td>
                  <td
                    :class="{
                      'red lighten-3 font-weight-bold': isExpired(item),
                    }"
                  >
                    {{ item.next_kyc_date }}
                  </td>
                  <td>{{ item.issue_date }}</td>
                  <td>{{ item.expire_date }}</td>
                  <td>{{ item.risk_profile }}</td>
                </template>
                <td v-if="trashed">{{ item.deleted_at }}</td>
                <td v-if="can.any">
                  <v-btn
                    flat
                    icon
                    small
                    class="ma-0"
                    v-if="can.view"
                    color="grey darken-1"
                    :to="`individuals/${item.customer_id}`"
                  >
                    <v-icon>launch</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    flat
                    class="ma-0"
                    color="grey darken-1"
                    v-if="can.edit && !kyc"
                    :to="`individuals/edit/${item.customer_id}`"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    flat
                    small
                    class="ma-0"
                    color="grey darken-1"
                    @click="deleteItem(item)"
                    v-if="can.delete && !kyc"
                  >
                    <v-icon>delete_outline</v-icon>
                  </v-btn>
                  <!-- <v-btn
                    icon
                    flat
                    small
                    class="ma-0"
                    color="grey darken-1"
                    @click="restoreItem(item)"
                    v-if="can.delete && !kyc"
                  >
                    <v-icon>restore</v-icon>
                  </v-btn> -->
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import debounce from "@/plugins/vDebounce";
import { customersMixin } from "@/mixins/index.js";
import newBranch from "../branchs/newBranch.vue";

export default {
  name: "individuals",
  components: { newBranch },
  mixins: [customersMixin],
  data() {
    return {
      items: [],
      search: "",
      selected: [],
      dialog: false,
      trashed: false,
      loading: false,
      pep: false,
      temporary: false,
      sanction_screening: false,
      meta: {
        total: 0,
        perPage: 0,
        current_page: 0,
      },
      customer: {
        files: [],
        accounts: [],
      },
      totalRows: 0,
      loading: true,
      editedIndex: -1,
      pagination: { page: 1, rowsPerPage: 100 },
    };
  },

  computed: {
    can() {
      return {
        add: this.userCan(`add_individuals`),
        view: this.userCan(`view_individuals`),
        edit: this.userCan(`edit_individuals`),
        delete: this.userCan(`delete_individuals`),
        any:
          this.userCan(`edit_individuals`) ||
          this.userCan(`view_individuals`) ||
          this.userCan(`delete_individuals`),
      };
    },

    kyc() {
      let kyc = this.$store.state.route.query.kyc;
      return !!kyc;
    },

    title() {
      if (this.kyc) return "Individuals Report";
      else return "Individuals List";
    },

    currencies() {
      return this.initialData.currencies;
    },
    headers: (vm) => {
      let items = [
        {
          value: "index",
          width: "80px",
          sortable: false,
          text: vm.$t("number"),
        },
        {
          sortable: false,
          value: "branch.code",
          text: vm.$t("branch"),
        },
        {
          width: "80px",
          sortable: false,
          value: "customer_id",
          text: vm.$t("reg_no"),
        },
        {
          sortable: false,
          value: "full_name",
          text: vm.$t("customer"),
        },
        {
          sortable: false,
          text: vm.$t("phones"),
          value: "pretty_phones",
        },
        {
          sortable: false,
          value: "tazkira_no",
          text: vm.$t("tazkira_no"),
        },
        {
          sortable: false,
          value: "passport_no",
          text: vm.$t("passport_no"),
        },
        {
          sortable: false,
          value: "current_address",
          text: vm.$t("current_address"),
        },
        {
          sortable: false,
          value: "reg_date",
          text: vm.$t("reg_date"),
        },
      ];

      if (vm.kyc) {
        items.push(
          {
            sortable: false,
            value: "kyc_updated_date",
            text: vm.$t("kyc_updated_date"),
          },
          {
            sortable: false,
            value: "next_kyc_date",
            text: vm.$t("next_kyc_date"),
          },
          {
            sortable: false,
            value: "issue_date",
            text: "Passport " + vm.$t("issue_date"),
          },
          {
            sortable: false,
            value: "expire_date",
            text: "Passport " + vm.$t("expire_date"),
          },
          {
            sortable: false,
            value: "risk_profile",
            text: vm.$t("risk_profile"),
          }
        );
      }

      //       KYC Date, Next KYC Date, Issunace Passport Date,Expire Passport Date,
      // Risk Category

      if (vm.trashed) {
        items.push({
          sortable: false,
          hidePrint: true,
          value: "deleted_at",
          text: vm.$t("deleted_at"),
        });
      }
      items.push({
        sortable: false,
        value: "actions",
        text: vm.$t("actions"),
      });
      return items;
    },
  },
  methods: {
    isExpired(item) {
      return !item.next_kyc_date || new Date(item.next_kyc_date) <= new Date();
    },
    getData() {
      this.loading = true;
      let { search, trashed, pep, sanction_screening, temporary } = this;
      const { page, rowsPerPage } = this.pagination;
      let params = {
        pep,
        page,
        search,
        trashed,
        temporary,
        type: "individual",
        sanction_screening,
        per_page: rowsPerPage,
      };
      this.axios
        .get(`individuals`, { params })
        .then((resp) => {
          this.items = resp.data.data;
          this.meta = resp.data.meta;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    editItem(item, index) {
      this.customer = { ...item };
      this.editedIndex = index;
      this.dialog = true;
    },

    deleteItem(item) {
      let vm = this;
      this.$alert("customers/" + item.customer_id).then(() => {
        vm.items.splice(vm.items.indexOf(item), 1); // remove items
      });
    },

    reset() {
      this.dialog = false;
      this.customer = {
        name: "",
        phones: "",
        address: "",
        type: "individual",
        last_form_number: 100,
      };
      this.editedIndex = -1;
    },

    showDialog() {
      this.reset();
      this.dialog = true;
    },

    save(customer) {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], customer);
      } else {
        this.items.push(customer);
      }
      this.reset();
    },

    printTable(excel) {
      let headers = this.headers.slice(1, -1);
      if (excel)
        headers.push(
          {
            sortable: false,
            value: "father_name",
            text: this.$t("father_name"),
          },
          {
            sortable: false,
            value: "date_of_birth",
            text: this.$t("date_of_birth"),
          },
          {
            sortable: false,
            value: "place_of_birth",
            text: this.$t("place_of_birth"),
          },
          {
            sortable: false,
            value: "gender",
            text: this.$t("gender"),
          },
          {
            sortable: false,
            value: "marital_status",
            text: this.$t("marital_status"),
          },

          {
            sortable: false,
            text: this.$t("email"),
            value: "email",
          },
          {
            sortable: false,
            value: "nature_of_business",
            text: this.$t("nature_of_business"),
          },
          {
            sortable: false,
            value: "source_of_income",
            text: this.$t("source_of_income"),
          },
          {
            sortable: false,
            value: "monthly_income",
            text: this.$t("monthly_income"),
          },
          {
            sortable: false,
            value: "monthly_turnover",
            text: this.$t("monthly_turnover"),
          },
          {
            sortable: false,
            value: "tin_number",
            text: this.$t("tin_number"),
          },
          {
            sortable: false,
            value: "tenure",
            text: this.$t("tenure"),
          },
          {
            sortable: false,
            value: "tin_number",
            text: this.$t("tin_number"),
          },
          {
            sortable: false,
            value: "current_address",
            text: this.$t("current_address"),
          },
          {
            sortable: false,
            value: "permanent_address",
            text: this.$t("permanent_address"),
          },
          {
            sortable: false,
            value: "kyc_notes",
            text: this.$t("kyc_notes"),
          }
        );
      let data = {
        headers,
        landscape: true,
        title: this.title,
        items: this.$refs.tbl.filteredItems,
      };

      if (excel) return this.xl_tables(data, "individuals", this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },
  },
  created() {
    this.reset();
  },
  watch: {
    pagination: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    search: debounce(function (newVal) {
      this.getData(newVal);
    }, 1000),
  },
};
</script>